export default function SectionLabel({ color = "#005C40", label, center }) {
  return (
    <div
      className="flex items-center gap-2 mb-2.5"
      style={{ justifyContent: center ? "center" : "flex-start" }}
    >
      <div
        className="w-7 h-[3px] rounded-sm"
        style={{ background: color }}
      />
      <span
        className="text-[11px] font-bold tracking-[0.14em] uppercase"
        style={{ color }}
      >
        {label}
      </span>
    </div>
  );
}
